import { render, staticRenderFns } from "./BlockedUsers.vue?vue&type=template&id=f9f18d88&scoped=true&"
import script from "./BlockedUsers.vue?vue&type=script&lang=js&"
export * from "./BlockedUsers.vue?vue&type=script&lang=js&"
import style0 from "./BlockedUsers.vue?vue&type=style&index=0&id=f9f18d88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9f18d88",
  null
  
)

export default component.exports